var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAccountTerms = function SvgIconAccountTerms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.75 5v9.745a.75.75 0 0 1-.745.755H.995a.745.745 0 0 1-.745-.744V1.244C.25.84.587.5 1.002.5h8.246zm-1.5.75H8.5V2H1.75v12h10.5z"
  })));
};
export default SvgIconAccountTerms;